import React, { useState, useEffect } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { CoachesService } from '../../services/coachesService';
import { Coach } from '../../types/coach';
import ViewStudentsDialog from './ViewStudentsDialog';
import { Link } from "react-router-dom";

const Coaches = () => {
  const [coaches, setCoaches] = useState<Coach[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCoachId, setSelectedCoachId] = useState<string | null>(null);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    loadCoaches();
  }, []);

  const loadCoaches = async () => {
    try {
      setIsLoading(true);
      const coachesData = await CoachesService.getAllCoaches();
      setCoaches(coachesData);
    } catch (error) {
      console.error('Error loading coaches:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewStudents = (coachId: string) => {
    setSelectedCoachId(coachId);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedCoachId(null);
  };

  return (
    <React.Fragment>
      <BreadCrumb title='Coaches' pageTitle='Dashboard' />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-12 gap-x-5">
        {isLoading ? (
          <div className="flex items-center justify-center h-64 col-span-full mt-20">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          </div>
        ) : (
          coaches.map((coach) => (
            <div className="lg:col-span-1 xl:col-span-3" key={coach.id}>
              <div className="card">
                <div className="card-body">
                  <div className="flex items-center justify-center size-16 mx-auto rounded-full bg-slate-100 dark:bg-zink-600">
                    <img
                      src={coach.photoUrl || ''}
                      alt=""
                      className="h-16 w-16 rounded-full object-cover"
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                        const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                        if (nextElement) nextElement.style.display = 'flex';
                      }}
                    />
                    <div className="size-16 rounded-full bg-gray-100 dark:bg-gray-500/20 items-center justify-center hidden">
                      <span className="text-gray-500 text-2xl">👤</span>
                    </div>
                  </div>

                  <div className="mt-4 mb-6 text-center">
                    <h6 className="text-16"><Link to="#!">{coach.fullName}</Link></h6>
                    <p className="text-slate-500 dark:text-zink-200">@{coach.userName}</p>
                  </div>
                  <div className="text-center">
                    <button
                      onClick={() => handleViewStudents(coach.id)}
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      View Students
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      {selectedCoachId && (
        <ViewStudentsDialog
          coachId={selectedCoachId}
          onClose={handleCloseDialog}
          show={showDialog}
        />
      )}
    </React.Fragment>
  );
};

export default Coaches;